import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { CheckBox, Button } from 'Components';
import TestPickListParameter from '../TestPickListParameter/TestPickListParameter';
import './TestPickListTest.css';

const TestPickListPackage = ({
  onParameterCheck,
  onParameterCheckAll,
  onTestCollapse,
  Parameters,
  collapsed,
  HasParameters,
  isTestHeaderShown,
  DisplayLabels,
  bin,
  IsReadOnly,
}) => (
  <Fragment>
    <div className="test-pick-list-test">
      <CheckBox onClick={() => null} />
      <Button className="test-pick-list-test__collapse" onClick={onTestCollapse}>
        <div>
          { (DisplayLabels || []).map(x => <div key={x.line}>{x.Label}</div>) }
        </div>
      </Button>
      {(HasParameters || (Parameters !== undefined && Parameters.length > 0)) &&
        <Button onClick={onTestCollapse}>
          <i className="material-icons" style={collapsed ? { transform: 'rotate(180deg)' } : undefined}>arrow_drop_up</i>
        </Button>
       }
    </div>
    {(!collapsed && (HasParameters || Parameters.length > 0)) &&
    <Fragment>
      { isTestHeaderShown &&
        <div className="test-pick-list-test__parameters-h1">
          <span>{i18n.t('formsTests:Parameter')}</span>
          <span>{i18n.t('formsTests:DetectionLimit')}</span>
        </div>
      }
      {!IsReadOnly &&
      <div className="test-pick-list-test__parameters-h2">
        <CheckBox
          checked={Parameters.every(x => x.ToggleOn)}
          onClick={onParameterCheckAll}
          disabled={Parameters.some(Parameter => Parameter.ReadOnly)}
          isParameter
        />
        <span>{i18n.t('formsTests:SelectAllParameters')}</span>
      </div>}
    </Fragment>
    }
    {!collapsed &&
      Parameters.map((Parameter, m) => (
        <TestPickListParameter
          {...Parameter}
          bin={bin}
          key={`${bin}-TestPickList-${Parameter.ParameterName}-${m}`}
          onParameterCheck={() => onParameterCheck(m)}
          IsReadOnly={IsReadOnly}
          IsDisabled={Parameter.ReadOnly}
          IsParameter
        />))
    }
  </Fragment>
);

TestPickListPackage.propTypes = {
  collapsed: PropTypes.bool,
  onTestCollapse: PropTypes.func,
  onParameterCheck: PropTypes.func,
  onParameterCheckAll: PropTypes.func,
  Parameters: PropTypes.arrayOf(PropTypes.shape({})),
  DisplayLabels: PropTypes.arrayOf(PropTypes.shape({})),
  isTestHeaderShown: PropTypes.bool,
  bin: PropTypes.string,
  IsReadOnly: PropTypes.bool,
 };

export default TestPickListPackage;



// WEBPACK FOOTER //
// ./src/components/TestPickList/TestPickListTest/TestPickListTest.jsx